export default function convertQueryStringToObject(queryString = '') {
    const queryParams = queryString.split('&');
    return queryParams.reduce((acc, next) => {
        const keyAndValue = next.split('=');
        if (keyAndValue.length > 0) {
            const key = keyAndValue[0];
            acc[key] = keyAndValue[1];
        }
        return acc;
    }, {});
}



// WEBPACK FOOTER //
// ./app/lib/format/convertQueryStringToObject.js